/**
 * MD5 helpers — mirrors packages/amgbandarqq_v2 lobby_screen.dart:139
 *   md5(agentId + gameKey + userName)   for openGame/balance/placeBet
 *   md5(userName)                       for getInfo
 */
import { md5 } from 'js-md5';

export function md5Hex(input: string): string {
  return md5(input);
}

export function generateBalanceMd5(
  agentId: string,
  gameKey: string,
  userName: string,
): string {
  return md5Hex(`${agentId}${gameKey}${userName}`);
}

export function generateInfoMd5(userName: string): string {
  return md5Hex(userName);
}
